import React from 'react';
import Styles from '../assets/css/termsConditions.module.scss';
import { FaPlus } from "react-icons/fa6";
import { useNavigate } from 'react-router';

const TermsConditions = () => {
    const navigate = useNavigate();

    const handleIconClick = () => {
        navigate('/signup');
    };

    return (
        <div className={`${Styles.terms}`}>
            <div className={`${Styles.sub_terms}`}>
                <h2>Terms and Conditions</h2>
                <FaPlus onClick={handleIconClick} />
            </div>
            <div className={`${Styles.terms_content}`}>
                <h4>Welcome to our Mawj Music! By using our services, you agree to the following terms and conditions:</h4>

                <h3>1. Acceptance of Terms</h3>
                <p>By accessing or using our app, you agree to be bound by these terms. If you do not agree, do not use our services.</p>

                <h3>2. User Accounts</h3>
                <p>To access certain features, you may need to create an account. You are responsible for maintaining the confidentiality of your account information.</p>

                <h3>3. Content Ownership</h3>
                <p>All content provided in the app, including music, artwork, and text, is owned by us or our licensors. You may not reproduce, distribute, or create derivative works without permission.</p>

                <h3>4. User Content</h3>
                <p>You retain ownership of any content you upload. However, by uploading content, you grant us a worldwide, non-exclusive, royalty-free license to use, reproduce, and distribute that content.</p>

                <h3>5. Prohibited Activities</h3>
                <p>You agree not to engage in any of the following prohibited activities:</p>
                <ul>
                    <li>Harassment or intimidation of other users.</li>
                    <li>Posting false or misleading information.</li>
                    <li>Using the app for any illegal activities.</li>
                </ul>

                <h3>6. Termination</h3>
                <p>We reserve the right to suspend or terminate your account at any time for any reason, including violation of these terms.</p>

                <h3>7. Limitation of Liability</h3>
                <p>Our liability is limited to the fullest extent permitted by law. We are not responsible for any indirect, incidental, or consequential damages.</p>

                <h3>8. Changes to Terms</h3>
                <p>We may update these terms from time to time. We will notify you of any changes by posting the new terms on this page.</p>

                <h3>9. Contact Us</h3>
                <p>If you have any questions about these terms, please contact us at mawj@music.com.</p>

                <p>Thank you for using our Music App!</p>
            </div>
        </div>
    );
}

export default TermsConditions;